// Keyboard-cascade focus helpers (order-create flow). Encodes two antd v3
// gotchas ONCE, browser-verified 2026-07-16:
//   1. The focusable node of an antd Select is the inner .ant-select-selection
//      (tabIndex lives there) — calling .focus() on the outer .ant-select div
//      silently does nothing.
//   2. A Select with CONTROLLED `open` never moves focus onto its inner search
//      input on programmatic opens, and that input is where all keyboard
//      handling (arrows / Enter / type-ahead) lives — so cascade steps must
//      chase focus explicitly.

// Focus an element, resolving antd Selects to their real focusable node.
export const focusAntdNode = (el) => {
  if (!el) return;
  const target =
    el.classList && el.classList.contains("ant-select")
      ? el.querySelector(".ant-select-selection") || el
      : el;
  if (target && target.focus) target.focus();
};

// Defer-then-focus: `resolve` is an element or a function returning one
// (evaluated AFTER the delay, so it sees the post-render DOM). Returns the
// timer id for optional cleanup. Delays are per-call-site and deliberate —
// they absorb the setState re-renders that would otherwise drop the focus.
export const deferFocus = (resolve, delay = 150) =>
  setTimeout(() => {
    focusAntdNode(typeof resolve === "function" ? resolve() : resolve);
  }, delay);
